import getParametersFromUrl from './getParamatersFromUrl';

const getServerUrl = (): string => {
  const params = getParametersFromUrl();
  return `${params.protocol}//${params.domain}`;
};

export default getServerUrl;
